import React from "react";

// styling
import "./ManageBonus.css"

// constants
import {ADD_BONUS, BONUS, BONUS_FIELDS, BONUS_PAGES} from "./constants";

// custom components
import TopToolbar from "../../global/subcomponents/topToolbar/TopToolbar";
import TwoStepDelete from "../../global/subcomponents/twoStepDelete/TwoStepDelete";

// mui components and icons
import {TableCell} from "@material-ui/core";
import TablePage from "../../global/Table/TablePage";
import {Layout} from "../../global/Table/TablePageHelpers/LayoutObject";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import {IconButton} from "@mui/material";
import EditIcon from '@material-ui/icons/Edit';
import ToggleOnIcon from '@mui/icons-material/ToggleOn';
import ToggleOffIcon from '@mui/icons-material/ToggleOff';



class ManageBonusTable extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            deleteId: null,
        }
    }


    getContextualMenuItems = () => {
        let menuItems = []

        menuItems.push(
            {
                title: ADD_BONUS,
                icon: <AddCircleIcon/>,
                onClick: () => this.props.setCurrentPage(BONUS_PAGES.FORM, {})
            }
        )

        return menuItems
    }



    getTableHeaders = () => {
        let headers = []
        headers.push(Layout.columnHead(null,null,null))
        BONUS_FIELDS.forEach((headCell) => {
            headers.push(Layout.columnHead(headCell.label, headCell.id))
        })
        headers.push(Layout.columnHead(null,null,'right'))
        return headers
    }


    tableRow = (data) => {

        return (
            <React.Fragment>


                <TableCell>
                    <div className="rowSpecSuppliers" style={{marginRight:"16px",marginLeft:"16px"}}>
                        <IconButton size="small" onClick={() =>
                           this.props.handleBonusEditRow(data)
                        }>
                            <EditIcon />
                        </IconButton>
                    </div>

                </TableCell>
                <TableCell className="table-cell-left custom-width-name">{data?.name}</TableCell>

                <TableCell className="table-cell-left">
                    {data?.enabled ? (
                        <ToggleOnIcon style={{ color: 'green', fontSize: '36px' }} />
                    ) : (
                        <ToggleOffIcon style={{ color: 'red', fontSize: '36px' }} />
                    )}
                </TableCell>

                <TwoStepDelete
                    rowId={data.manageBonusId}
                    handleDelete={(rowIdToDelete) => this.props.handleDeleteRow(data.manageBonusId)}
                    deleteId={this.state.deleteId}
                    setDeleteId={(newDeleteId) => this.setState({deleteId: newDeleteId})}
                />
            </React.Fragment>
        )
    }

    searchStrings = (data) => {
        return [data.name]
    }

    render() {
        return (
            <>
                <TopToolbar
                    pageName={BONUS}
                    menuItems={this.getContextualMenuItems()}
                />
                <TablePage
                    tableName="bonusTable"
                    tableRows={this.props.bonus}
                    tableColumnHeads={this.getTableHeaders()}
                    tableRow={this.tableRow}
                    paginationText="Results"
                    hasSearchField
                    searchStrings={this.searchStrings}
                    defaultSortBy="name"
                />

            </>
        )
    }
}


export default ManageBonusTable;
